import React, {useState} from 'react';
import styled from '@emotion/styled';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';

const getInitialState = (options) => {
  if (!options) {
    return []
  }
  return options.map((option, index) => {
    return {
      id: option,
      content: `${index}. ${option}`
    }
  })
}
const grid = 8;
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const QuoteItem = styled.div`
  width: 200px;
  border: 1px solid blue;
  margin-bottom: ${grid}px;
  padding: ${grid}px;
`;

function Quote({quote, index}) {
  return (
    <Draggable draggableId={quote.id} index={index}>
      {provided => (
        <QuoteItem
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {quote.content}
        </QuoteItem>
      )}
    </Draggable>
  );
}

const QuoteList = React.memo(({quotes}) => {
  return quotes.map((quote, index) => (
    <Quote quote={quote} index={index} key={quote.id}/>
  ));
});

export default function OptionsDnD({options}) {
  const [state, setState] = useState({quotes: getInitialState(options)});

  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const quotes = reorder(
      state.quotes,
      result.source.index,
      result.destination.index
    );

    setState({quotes});
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="list">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <QuoteList quotes={state.quotes}/>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
